<div class="container">
    <span class="fw-bold">Por favor diligencie o registre los datos que se deben verificar</span>

    <br>
    <br>

    <div class="form-check">
        <label class="list-group-item" *ngFor="let data of $parametricList.typeValidationsList; let i = index">
            <input class="form-check-input" type="checkbox" 
                (change)="onSelectCheck($event)"
                [value]="data.idParametroDetalle" [id]="i">
            <span class="ms-3">{{ data.txDescripcion }}</span>
        </label>
    </div>

    <br>

    <div class="row">
        <div class="col-12" [formGroup]="observacionForm">
            <div *ngIf="dataTxtValidationDatosJson.length >= 1">
                <label for="" class="form-label">Justificación*</label>
                <textarea class="form-control" rows="2" maxlength="800" name="justificacion"
                    formControlName="TxtObservacion" (input)="onTextareaInput($event)" required>
                </textarea>
    
                <strong class="invalid-feedback d-block"
                    *ngIf="observacionForm.get('TxtObservacion')?.invalid && (observacionForm.get('TxtObservacion')?.dirty || observacionForm.get('TxtObservacion')?.touched)">
                    <span *ngIf="observacionForm.get('TxtObservacion')?.errors?.['required']">
                        Campo obligatorio
                    </span>
                </strong>
            </div>
        </div>
    </div>

    <br>

    <div class="d-flex flex-row justify-content-end float-end col-2">
        <button class="btn btn-secondary ms-auto col-12 me-3" (click)="onEnviar()" 
            [disabled]="dataTxtValidationDatosJson.length < 1 || observacionForm.value.TxtObservacion.length < 1">
                ENVIAR SOLICITUD
        </button>
        <button class="btn btn-secondary ms-auto col-12" (click)="onCancel()">
            CANCELAR
        </button>
    </div>
</div>